import { BookOpen, CalendarCheck, ClipboardList, FolderDown, HelpCircle, Home, IndianRupee, LineChart, MessageSquare, PenLine, Video } from 'lucide-react';
import type { NavGroup, PaletteCommand } from './types';

/** Parent app: how is my child doing, what is due, and a line to the mentor. */
export const parentNav: readonly NavGroup[] = [
  {
    id: 'child',
    items: [
      { id: 'home', label: 'Home', to: '/parent', icon: Home, end: true, tab: true, keywords: ['overview', 'summary', 'dashboard'] },
      { id: 'progress', label: 'Progress', to: '/parent/progress', icon: LineChart, tab: true, keywords: ['tests', 'marks', 'rank', 'results', 'report card'] },
      { id: 'attendance', label: 'Attendance', to: '/parent/attendance', icon: CalendarCheck, tab: true, keywords: ['absent', 'present', 'timetable', 'classes'] },
    ],
  },
  {
    id: 'learning',
    label: 'Learning',
    items: [
      { id: 'homework', label: 'Homework', to: '/parent/homework', icon: ClipboardList, keywords: ['assignment', 'dpp', 'due'] },
      { id: 'material', label: 'Study material', to: '/parent/material', icon: FolderDown, keywords: ['notes', 'download', 'pdf', 'pyq'] },
      { id: 'lectures', label: 'Lectures', to: '/parent/lectures', icon: Video, keywords: ['live class', 'recording', 'watched'] },
      { id: 'practice', label: 'Practice', to: '/parent/practice', icon: PenLine, keywords: ['quiz', 'mcq', 'score'] },
      { id: 'doubts', label: 'Doubts', to: '/parent/doubts', icon: HelpCircle, keywords: ['questions', 'teacher'] },
    ],
  },
  {
    id: 'center',
    label: 'Center',
    items: [
      { id: 'messages', label: 'Messages', to: '/parent/messages', icon: MessageSquare, tab: true, keywords: ['mentor', 'teacher', 'meeting', 'ptm'] },
      { id: 'fees', label: 'Fees', to: '/parent/fees', icon: IndianRupee, keywords: ['dues', 'payment', 'receipt'] },
    ],
  },
];

export const parentCommands: readonly PaletteCommand[] = [
  { id: 'download-report', label: 'Download progress report', to: '/parent/progress', icon: BookOpen, keywords: ['report card', 'pdf'] },
  { id: 'request-meeting', label: 'Request a meeting', to: '/parent/messages', icon: MessageSquare, keywords: ['ptm', 'mentor'] },
];
